import httpCommon from "./http-common";

// Approval Workflows
const getApprovalWorkflows = (businessId: number) => {
  return httpCommon.get(`/v1/get/approvalWorkflow?businessId=${businessId}`);
};

const createApprovalWorkflow = (data: any) => {
  return httpCommon.post("/v1/add/approvalWorkflow", data);
};

const updateApprovalWorkflow = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/approvalWorkflow/${id}`, data);
};

const deleteApprovalWorkflow = (id: number) => {
  return httpCommon.delete(`/v1/delete/approvalWorkflow/${id}`);
};

const getApprovalWorkflowById = (id: number) => {
  return httpCommon.get(`/v1/get/approvalWorkflow/${id}`);
};

// Approval Steps
const getApprovalSteps = (approvalWorkflowId: number) => {
  return httpCommon.get(`/v1/get/approvalStep?approvalWorkflowId=${approvalWorkflowId}`);
};

const createApprovalStep = (data: any) => {
  return httpCommon.post("/v1/add/approvalStep", data);
};

const updateApprovalStep = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/approvalStep/${id}`, data);
};

const deleteApprovalStep = (id: number) => {
  return httpCommon.delete(`/v1/delete/approvalStep/${id}`);
};

// Approval Requests
const getApprovalRequests = (businessId: number, status?: string) => {
  const params = status ? `?businessId=${businessId}&status=${status}` : `?businessId=${businessId}`;
  return httpCommon.get(`/v1/get/approvalRequest${params}`);
};

const createApprovalRequest = (data: any) => {
  return httpCommon.post("/v1/add/approvalRequest", data);
};

const getApprovalRequestById = (id: number) => {
  return httpCommon.get(`/v1/get/approvalRequest/${id}`);
};

const updateApprovalRequest = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/approvalRequest/${id}`, data);
};

// Approval Actions
const processApprovalAction = (data: any) => {
  return httpCommon.post("/v1/add/approvalAction", data);
};

const getApprovalActions = (approvalRequestId: number) => {
  return httpCommon.get(`/v1/get/approvalAction?approvalRequestId=${approvalRequestId}`);
};

// Bulk operations
const bulkApproveRequests = (requestIds: number[], approverData: any) => {
  return httpCommon.post("/v1/bulk/approve/approvalRequest", {
    requestIds,
    ...approverData
  });
};

const bulkRejectRequests = (requestIds: number[], approverData: any) => {
  return httpCommon.post("/v1/bulk/reject/approvalRequest", {
    requestIds,
    ...approverData
  });
};

const ApprovalWorkflowsService = {
  // Workflows
  getApprovalWorkflows,
  createApprovalWorkflow,
  updateApprovalWorkflow,
  deleteApprovalWorkflow,
  getApprovalWorkflowById,
  
  // Steps
  getApprovalSteps,
  createApprovalStep,
  updateApprovalStep,
  deleteApprovalStep,
  
  // Requests
  getApprovalRequests,
  createApprovalRequest,
  getApprovalRequestById,
  updateApprovalRequest,
  
  // Actions
  processApprovalAction,
  getApprovalActions,
  
  // Bulk operations
  bulkApproveRequests,
  bulkRejectRequests,
};

export default ApprovalWorkflowsService; 